import { useState } from "react";
import Modal from "react-modal";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import axios from "axios";

Modal.setAppElement('#root');

const MiraLearnMoreModal = ({ isOpen, onClose, isHighmarkPortal, email, memberId, contract, serviceDescription }) => {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const deviceType = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
  const token = localStorage.getItem("AccessToken")

  const handleMaybeLater = () => {
    const event = new CustomEvent("miraMaybeLaterClicked");
    window.dispatchEvent(event);
    setShowErrorModal(true);
  };

  const getAndOpenMiraLink = async () => {
    const params = {
      EmailID: email,
      DeviceType: deviceType,
      Contract: contract,
      MemberID: memberId,
      ServiceDescription: serviceDescription,
      MiraLink: ""
    };

    try {
      const response = await axios.post(
        Endpoints.GetMiraLink,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data && response.data != "") {
        window.open(response.data, "_blank", 'noopener,noreferrer');
      }
      onClose();
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="tracker-modal-content-a"
      overlayClassName="tracker-modal-overlay"
      shouldCloseOnOverlayClick={false}
    >
      <h2 style={{ fontWeight: 700, fontSize: "1.5rem", marginBottom: "1rem", textAlign: "center" }}>
        What's Mira?
      </h2>
      <p style={{ marginBottom: "2rem", textAlign: "center" }}>
        {`Mira is an at-home, FDA-listed and CE-approved hormone tracker. With a quick urine test, it measures key hormones that influence your cycle and health. Results sync directly into the ${ isHighmarkPortal ? "Fertility and Family Building Portal" : "WINFamily App"} - so your Nurse Care Advocate and provider can better personalize your care plan. Mira helps turn hormone changes into clear insights you can act on. Want to learn more about Mira coverage?`}        </p>
      <div className="mb-4 row align-items-center" style={{ justifyContent: "center" }}>
        <div className="col-12 mb-3">
          <button
            className="win-btn-primary model-popup-btn w-100"
            style={{ borderRadius: "24px", fontWeight: 600 }}
            onClick={() => {getAndOpenMiraLink();}}
          >
            Learn More
          </button>
        </div>
        <div className="col-12">
          <button
            className="win-btn-secondary model-popup-btn w-100"
            style={{ borderRadius: "24px", fontWeight: 600 }}
            onClick={() => { onClose(); handleMaybeLater(); }}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </Modal>
    <ErrorModal
    show={showErrorModal}
    message={isHighmarkPortal ? "Thank you for sharing the data." : "Thank you for sharing the data with WIN."}
    onClose={() => {
      setShowErrorModal(false);
      onClose();
    }}
    closeButton={true}
  />
  </>
  );
};

export default MiraLearnMoreModal;
